import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { quoteActivityFormDefault } from "@factory/form/form.default";
import { QuoteActivityFormRule, QuoteActivityFormSchema } from "@factory/form/form.rule";
import { useQyCreateQuoteActivity } from "@factory/query/quote-activity.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewQuoteActivity() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateQuoteActivity } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New QuoteActivity is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addQuoteActivity, isLoading: isCreating } =
    useQyCreateQuoteActivity(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<QuoteActivityFormSchema>({
    defaultValues: quoteActivityFormDefault,
    resolver: zodResolver(QuoteActivityFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: QuoteActivityFormSchema) => {
    const formData = mapCreateQuoteActivity(form);
    addQuoteActivity(formData);
  };
  const handleValidateError = (err: FieldErrors<QuoteActivityFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
